window.REACT_APP_API_BASE_URL = "https://stats.carbonem.com/game";
let API_BASE_URL = window.REACT_APP_API_BASE_URL || "http://localhost:8181";

export { API_BASE_URL };

export const setApiBaseUrl = (newUrl) => {
  API_BASE_URL = newUrl; // Aggiorna il valore di API_BASE_URL
};

// Endpoints
export const API_ENDPOINTS = {
  statsTeams: `${API_BASE_URL}/api/protected/v1/football/stats-teams/search`,
  leagues: `${API_BASE_URL}/api/protected/v1/football/lookup/leagues`,
  teams: `${API_BASE_URL}/api/protected/v1/football/lookup/teams`,
  years: `${API_BASE_URL}/api/protected/v1/football/lookup/years`,
  matchStats: `${API_BASE_URL}/api/protected/v1/football/match-stats/search`,
  resourceCsv: `${API_BASE_URL}/api/protected/v1/football/config/resourceCsv`,
  resetDB: `${API_BASE_URL}/api/protected/v1/football/config/reset`,
  // WinHause Endpoints
  winHauseStats: `${API_BASE_URL}/api/protected/v1/lottery/win-hause/stats`,
  winHauseExtractions: `${API_BASE_URL}/api/protected/v1/lottery/win-hause/extractions`,
  winHauseExtractionsByDateRange: `${API_BASE_URL}/api/protected/v1/lottery/win-hause/extractions/by-date-range`,

  // SuperEnalotto Endpoints
  superEnalottoStats: `${API_BASE_URL}/api/protected/v1/lottery/superenalotto/stats`,
  superEnalottoExtractions: `${API_BASE_URL}/api/protected/v1/lottery/superenalotto/extractions`,
  superEnalottoExtractionsByDateRange: `${API_BASE_URL}/api/protected/v1/lottery/superenalotto/extractions/by-date-range`,

  // Lotto Endpoints
  lottoWheels: `${API_BASE_URL}/api/protected/v1/lottery/lotto/wheels`,
  lottoWheelStatistics: `${API_BASE_URL}/api/protected/v1/lottery/lotto/wheels`,
  lottoLatest: `${API_BASE_URL}/api/protected/v1/lottery/lotto/wheels`,
  lottoDelayNumbers: `${API_BASE_URL}/api/protected/v1/lottery/lotto/wheels`,
  lottoExtractionsByDateRange: `${API_BASE_URL}/api/protected/v1/lottery/lotto/wheels`,
  lottoExtractions: `${API_BASE_URL}/api/protected/v1/lottery/lotto/extractions`,
  lottoHealth: `${API_BASE_URL}/api/protected/v1/lottery/lotto/health`,


  // Fantasy Football Endpoints
  fantasyPlayers: `${API_BASE_URL}/api/protected/v1/football/fantasy/players`,
  fantasyStats: `${API_BASE_URL}/api/protected/v1/football/fantasy/stats`,
  fantasyFixtures: `${API_BASE_URL}/api/protected/v1/football/fantasy/fixtures`,
  fantasyLeaderboard: `${API_BASE_URL}/api/protected/v1/football/fantasy/leaderboard`,

  // User Management Endpoints
  users: `${API_BASE_URL}/api/protected/v1/users`,
  usersSearch: `${API_BASE_URL}/api/protected/v1/users/search`,
  usersCreate: `${API_BASE_URL}/api/public/v1/auth/register`, // Use auth/register endpoint for user creation
  roles: `${API_BASE_URL}/api/protected/v1/roles`,
  sections: `${API_BASE_URL}/api/protected/v1/sections`,
  sectionsPublic: `${API_BASE_URL}/api/protected/v1/sections/public`,
};

export const ENVIRONMENT = {
  apiBaseUrl: API_BASE_URL
};

